import { TabViews } from '@dfl/mui-admin-layout';
import { disabledB2B } from 'utils/flags-utils';

export const productTabs: TabViews = {
  all: {
    title: 'all',
    filters: {},
  },
  active: {
    title: 'visible',
    filters: {
      type: 'TERM',
      field: 'visible',
      value: true,
    },
  },
  inactive: {
    title: 'noVisible',
    filters: {
      type: 'TERM',
      field: 'visible',
      value: false,
    },
  },
  ...(!disabledB2B
    ? {
        business: {
          title: 'business',
          filters: {
            type: 'TERM',
            field: 'rules.onlyBusiness',
            value: true,
          },
        },
      }
    : {}),
};
